<div class="discuss-box scrollbar-custom" id="discuss-box" [ngClass]="{'toggle-box': !toggle}">
    <div class="header" (click)="onClick()">
        <div class="arrow down" [ngClass]="{'down': toggle, 'up': !toggle}"></div>
    </div>
    <div class="title">
        <span class="text-title">Discussion</span>
        <span *ngIf="!toggle" class="total">{{total < 99 ? total : '99+'}}</span>
    </div>

    <div class="body" *ngIf="toggle" #scrollMe>
        <div class="comment-item" *ngFor="let item of comments" #item>
            <div [ngClass]="{'avatar': item?.request_discussion_user?.avatar, 'avatar-default': !item?.request_discussion_user?.avatar}">
                <img class="img" [src]="item?.request_discussion_user?.avatar">
            </div>
            <div class="content">
                <div class="time">{{ showTime(item?.created_date) }}</div>
                <div class="name">{{item?.request_discussion_user?.name}}
                    <span *ngIf="item?.user_type_name" style="text-transform:capitalize;">({{ item?.user_type_name }})</span>
                </div>
                <div class="message">{{item.comment}}</div>
            </div>
        </div>
    </div>
    <div class="footer" *ngIf="toggle">
        <form [formGroup]="form" (keyup.enter)="onSubmit(form.value)">
            <textarea id="message" rows="2" placeholder="Write a comment"
                formControlName="message"></textarea>
        </form>
    </div>
</div>